var Ractive = require('ractive');
var template = require('Templates/default.html');


var view = function(data, ready_cb) {

	var ractive = new Ractive({
		el : "#container",
		template: template,
		data : data
	});

	if (ready_cb) ready_cb();
}



module.exports = view;
